import { Component, Element, h, Method, Prop } from '@stencil/core';
import { ShippingPriceType } from '../../../../redux/types';
import { StepErrorType } from '../../../../types/types';
import { formatPrice } from '../../../../redux/utils';

@Component({
  tag: 'rentware-checkout-shipping-template',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareCheckoutShippingTemplate {
  @Prop() options: any[];
  @Prop() selectedOption: string;
  @Prop() onOptionChange: (e: any, item: any) => void;
  @Prop() currentStep;
  @Prop() errors;
  @Prop() typedAddress: string;
  @Prop() onAddressInput: (e: string) => void;
  @Prop() onHintClick: () => void;
  @Prop() closeHint: () => void;
  @Prop() addressLabel: string;
  @Prop() pickOptionText: string;
  @Prop() enterAddressText: string;
  @Prop() addressHint: string;
  @Prop() addressInInput: string;
  @Prop() addressFieldDescription: string;
  @Prop() addressFieldDescriptionSuccess: string;
  @Prop() openAddressHint: boolean;
  @Prop() waitingForCalculation: boolean;

  @Element() el: HTMLElement;

  @Method()
  async goToFirstError() {
    if (this.errors?.some(error => error.type === StepErrorType.ShippingDistanceProblem)) {
      this.el.shadowRoot.querySelector('#Option')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      this.el.shadowRoot.querySelector('#Options')?.scrollIntoView({ behavior: 'smooth' });
    }
  }

  get optionsClass() {
    return (this.errors?.some(error => error.stepId === this.currentStep.id && error.type === StepErrorType.ShippingNoOptionSelected) && 'Option-Error') || '';
  }

  render() {
    return (
      <div class="ShippingContainer">
        <div class="ShippingContainerInner">
          {this.waitingForCalculation && <rentware-spinner withOverlay={true} />}

          <rentware-spacer size="M" />

          <span class="DeliveryTitle">{this.pickOptionText}</span>

          <rentware-spacer size="M" />

          <div class={this.optionsClass} id="Options">
            {this.options.map(item => {
              const isOptionSeleceted = item.id === this.selectedOption;
              const hasOptionError = isOptionSeleceted && this.errors?.some(error => error.stepId === this.currentStep.id && error.type === StepErrorType.ShippingDistanceProblem);
              const optionClass = hasOptionError ? 'ShippingItemContainer ShippingItemContainerError' : 'ShippingItemContainer';

              const showDistance = item.priceType === ShippingPriceType.Distance && isOptionSeleceted;
              const distanceHint = () => {
                if (showDistance) {
                  if (item.grossPrice > 0) {
                    return this.addressFieldDescriptionSuccess;
                  }

                  return this.addressFieldDescription;
                }
              };

              return (
                <div class={optionClass}>
                  <label class="ItemLabelContainer">
                    <rentware-radio
                      name="shippingOption"
                      value={item.id}
                      label={item.name}
                      labelEnd={formatPrice(item.grossPrice)}
                      checked={this.selectedOption === item.id}
                      onChange={e => this.onOptionChange(e, item)}
                    />
                  </label>

                  {showDistance && (
                    <div class="ItemCalculateContainer" id="Option">
                      <rentware-spacer size="S" />

                      <rentware-checkout-shipping-template-address
                        addressHint={this.addressHint}
                        addressLabel={this.addressLabel}
                        addressInInput={this.addressInInput}
                        openAddressHint={this.openAddressHint}
                        onHintClick={this.onHintClick}
                        closeHint={this.closeHint}
                        onAddressInput={this.onAddressInput}
                      />

                      <rentware-spacer size="S" />

                      <span>{distanceHint()}</span>

                      <rentware-spacer size="M" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <rentware-spacer size="XL" />
          <rentware-spacer size="XL" />
        </div>
      </div>
    );
  }
}
